// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"457":"0fe4bc88","708":"63fce24e"}[chunkId] + ".chunk.js";
};